module.exports = __webpack_public_path__ + "img/2375a869287fa6d818c362d44e217526d91ec1da.121b3bad.png";